import ActualizarHorariosNMP from "./ActualizarHorariosNMP";
export default ActualizarHorariosNMP;